/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-09-27 08:58:45
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-11-25 10:46:22
 * @FilePath: \ioc_base\src\modules\video\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const routes = [
  {
    path: "/videoMonitoringOld", // 主页面
    name: "videoMonitoring",
    redirect: "/videoMonitoringOld/index",
    component: () => import("./view/Home"),
    meta: {
      requireAuth: false,
      routerAlive: true
    },
    children: [
      {
        path: "dailyVideo", // 实时浏览
        name: "dailyVideo",
        component: () => import("./view/DailyVideo"),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: "index", // 实时浏览
        name: "realtime",
        //  component: () => import('./view/Video'),
        component: () => import("./view/DailyVideo"),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: "config", // 轮巡配置
        name: "config",
        component: () => import("./view/videoConfig"),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      }
    ]
  }
];

export default routes;
